export type { ChainHeadType } from "./ChainHeadType.js";

import { from as _from } from "./from.js";

// Export constructors
export { from } from "./from.js";

// Namespace export
export const ChainHead = {
	from: _from,
};
